module.exports = __webpack_public_path__ + "static/media/9.cf78b1ec.jpg";